// extracted by mini-css-extract-plugin
export var aircallIframe = "_ch-3";
export var fabContainer = "_ch-5";
export var fabRinging = "_ch-6";
export var loadingOverlay = "_ch-4";
export var pulse = "_ch-7";
export var widgetContent = "_ch-2";
export var widgetPanel = "_ch-0";
export var widgetPanelExpanded = "_ch-1";